import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Divider,
  Box,
  Link,
} from "@material-ui/core";
import { KeyboardArrowRight } from "@material-ui/icons";

import React from "react";

export function CampusLife(props) {
  const { data } = props;
  const preventDefault = (event) => event.preventDefault();

  const campusData = {
    typicalRoomAndBoard: {
      title: "Typical Room And Board",
      value: data.typicalRoomAndBoard,
    },
    onCampusHousingAvailable: {
      title: "On Campus Housing Available",
      value: data.onCampusHousingAvailable,
    },
    rankingsBestStudentLife: {
      title: "Rankings Best Student Life",
      value: data.rankingsBestStudentLife && data.rankingsBestStudentLife.value,
    },
    fraternitiesPercentParticipation: {
      title: "Fraternities Percent Participation",
      value: data.fraternitiesPercentParticipation,
    },
  };

  console.log(campusData);

  return (
    <Card className="pt-5 px-5">
      <CardHeader title="Campus Life"></CardHeader>
      <CardContent>
        <Grid container spacing={5}>
          <Grid item sm>
            <List>
              {[
                "typicalRoomAndBoard",
                "onCampusHousingAvailable",
                "rankingsBestStudentLife",
                "fraternitiesPercentParticipation",
              ].map((keyName, index) => (
                <Box key={index}>
                  <ListItem key={index}>
                    <ListItemText>
                      <Typography>{campusData[keyName].title}</Typography>
                    </ListItemText>
                    <ListItemSecondaryAction>
                      <Typography>
                        {campusData[keyName].value
                          ? campusData[keyName].value
                          : "--"}
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem>
                  <Divider />
                </Box>
              ))}
            </List>
          </Grid>
        </Grid>
      </CardContent>
      <hr className="mb-0" />
      <CardActions>
        <Typography variant="body1" color="primary" className="ml-auto mr-2">
        <Link
            href={window.location.href + "/campusLife"}
            onLClick={preventDefault}
          >
          Read More About Campus Life <KeyboardArrowRight />
          </Link>
        </Typography>
      </CardActions>
    </Card>
  );
}
